import Placeholder from '../../components/Placeholder';
import './AlphaPulse.scss';

export default function AlphaPulse() {
  return (
    <div className="alpha-pulse">
      <Placeholder page="Alpha Pulse" node="1:31180" />
    </div>
  );
}
